import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { IS_OPEN_AI_UP } from '../queries/isOpenAiUp';

/**
 * Fetches whether the OpenAI API is available. Returns:
 * - true: API is up and responding
 * - false: API is down or query errored
 * - undefined: Still loading
 */
export function useIsOpenAiUp(): boolean | undefined {
  const [isOpenAiUp, { data, loading, error }] = useLazyQuery(
    IS_OPEN_AI_UP,
    {},
  );

  useEffect(() => {
    isOpenAiUp();
  }, [isOpenAiUp]);

  if (loading) {
    return undefined;
  }

  if (error) {
    return false;
  }

  return data?.isOpenAiUp ?? false;
}
